/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppBarSearch } from '@plataforma/components';
import { PROCESS_STATUS } from '@plataforma/utils';
import { ENDORSEMENT_STATUS } from '_/utils/constants';
import DocumentDetail from '../../containers/DocumentDetail';
import EndorsementDetails from '../../containers/EndorsementDetail';
import IconButton from '../IconButton';
import ProcessDetailSkeleton from '../ProcessDetailSkeleton';
import * as S from './ProcessDetailWrapperStyles';
import ProcessTimeline from '../ProcessTimeline/ProcessTimeline';

function ProcessDetailWrapper({ policy, isFetching, onToastHandler }) {
  const { t } = useTranslation();

  function renderWarning(status) {
    return (
      <S.PageWarning status={status}>{t(`status.${status}`)}</S.PageWarning>
    );
  }

  function renderEndorsementDetails() {
    let { endorsements } = policy;
    if (
      policy.quoteStatus &&
      policy.quoteStatus.id === PROCESS_STATUS.quoteCanceled.id
    ) {
      endorsements = endorsements.filter(
        item => item.status !== ENDORSEMENT_STATUS.requestEmission
      );
    }

    return (
      <EndorsementDetails
        endorsements={endorsements}
        documentNumber={policy.documentNumber}
        policyStatus={policy.quoteStatus}
      />
    );
  }

  function renderContent() {
    if (!isFetching && policy) {
      return (
        <>
          {(policy.quoteStatus.groupName === 'underAnalysis' ||
            policy.quoteStatus.groupName === 'inProgress') &&
            renderWarning(policy.quoteStatus.groupName)}
          <S.Container>
            <S.Column>
              <DocumentDetail onToastHandler={onToastHandler} policy={policy} />
            </S.Column>
            <S.Column>
              {policy.process.type === 'policy' ? (
                renderEndorsementDetails()
              ) : (
                <ProcessTimeline policy={policy} />
              )}
            </S.Column>
          </S.Container>
        </>
      );
    }

    return <ProcessDetailSkeleton />;
  }

  return (
    <S.Wrapper>
      <AppBarSearch hideInput />
      <S.PageContent>
        <Link to="/" style={{ textDecoration: 0 }}>
          <IconButton>{t('policyDetail.backButton')}</IconButton>
        </Link>
        {renderContent()}
      </S.PageContent>
    </S.Wrapper>
  );
}

ProcessDetailWrapper.propTypes = {
  policy: PropTypes.shape({
    documentNumber: PropTypes.string,
    quoteStatus: PropTypes.shape({
      groupName: PropTypes.string
    }),
    process: PropTypes.shape({
      type: PropTypes.string
    }),
    endorsements: PropTypes.arrayOf(PropTypes.object)
  }),
  onToastHandler: PropTypes.func,
  isFetching: PropTypes.bool
};

export default ProcessDetailWrapper;
